import React, { useEffect } from "react";
import PageMeta from "../components/PageMeta";

const MasomoPrivacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageMeta
        title="Politique de confidentialité de Masomo | WonyaSoft"
        description="Politique de confidentialité de l'application scolaire Masomo : données traitées, finalités, sécurité, conservation et droits des utilisateurs."
      />

      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Politique de confidentialité de Masomo</h1>
          <p>Dernière mise à jour : 26 septembre 2026</p>
        </div>
      </section>

      <section className="legal-page-container" aria-label="Politique de confidentialité de Masomo">
        <p>
          Masomo est une application de gestion scolaire proposée par WONYA SOFT
          S.A. Cette politique explique les données traitées par Masomo, les
          raisons de leur traitement et les moyens disponibles pour exercer vos
          droits.
        </p>

        <article>
          <h2>1. Responsable et contact</h2>
          <p>
            WONYA SOFT S.A est responsable du service Masomo. Pour toute question
            relative à la protection des données, écrivez à{" "}
            <a href="mailto:dpo@wonyapay.com">dpo@wonyapay.com</a> ou à{" "}
            <a href="mailto:contact@wonyasoft.com">contact@wonyasoft.com</a>.
          </p>
        </article>

        <article>
          <h2>2. Données traitées</h2>
          <p>
            Masomo traite les informations nécessaires au fonctionnement d'un
            compte scolaire autorisé. Selon le rôle et les permissions attribués,
            ces informations peuvent comprendre :
          </p>
          <ul>
            <li>
              le code de l'école, le numéro de téléphone de connexion,
              l'identité, le rôle et les autorisations de l'utilisateur ;
            </li>
            <li>
              les informations relatives aux élèves, responsables, membres du
              personnel, classes et inscriptions ;
            </li>
            <li>
              les frais, factures, reçus, demandes de paiement et références de
              transaction ;
            </li>
            <li>
              les présences, évaluations, notes, bulletins et communications
              scolaires ;
            </li>
            <li>
              les journaux techniques et de sécurité nécessaires à la
              traçabilité du service.
            </li>
          </ul>
        </article>

        <article>
          <h2>3. Finalités du traitement</h2>
          <p>
            Ces données servent à authentifier les utilisateurs, présenter
            l'espace de leur établissement, gérer les activités administratives
            et pédagogiques, traiter les opérations autorisées, produire les
            documents scolaires, assurer la communication, prévenir les abus et
            maintenir la sécurité du service.
          </p>
        </article>

        <article>
          <h2>4. Accès et partage</h2>
          <p>
            Les données sont accessibles selon les droits attribués par
            l'établissement. Elles peuvent être transmises aux services
            WonyaPay ou WonyaSMS et, lorsqu'une opération l'exige, aux
            prestataires de paiement, de télécommunication, d'hébergement ou de
            sécurité concernés. WONYA SOFT S.A ne vend pas les données
            personnelles traitées par Masomo.
          </p>
        </article>

        <article>
          <h2>5. Sécurité et stockage local</h2>
          <p>
            Les échanges avec les services Masomo utilisent HTTPS. Sur Windows,
            les informations de session et certaines demandes en attente sont
            protégées par les mécanismes de sécurité du système afin de permettre
            une reprise contrôlée après une interruption réseau. Les données
            locales sont séparées par compte et par école.
          </p>
        </article>

        <article>
          <h2>6. Fonctionnement hors connexion</h2>
          <p>
            Masomo peut conserver localement des données déjà ouvertes et
            certaines saisies pédagogiques en attente. Les paiements, les SMS,
            les publications et les opérations administratives qui exigent une
            confirmation restent soumis à la réponse du service en ligne.
          </p>
        </article>

        <article>
          <h2>7. Conservation</h2>
          <p>
            Les données sont conservées pendant la durée nécessaire au
            fonctionnement du service scolaire, à la sécurité, au règlement des
            demandes et au respect des obligations légales applicables. Les
            durées peuvent varier selon la nature des informations et les
            obligations de l'établissement.
          </p>
        </article>

        <article>
          <h2>8. Droits des personnes</h2>
          <p>
            Pour demander l'accès, la rectification, la suppression ou la
            limitation du traitement de données, contactez d'abord votre
            établissement scolaire, puis WONYA SOFT S.A si nécessaire. Une
            vérification d'identité peut être demandée afin de protéger les
            personnes concernées.
          </p>
        </article>

        <article id="suppression">
          <h2>Demander la suppression du compte Masomo</h2>
          <p>Pour demander la suppression de votre compte Masomo ou Masomo Mobile et des données personnelles associées, écrivez à <a href="mailto:contact@wonyasoft.com?subject=Suppression%20du%20compte%20Masomo">contact@wonyasoft.com</a> avec l'objet « Suppression du compte Masomo ». Vous pouvez effectuer cette demande sans réinstaller l'application.</p>
          <p>Indiquez le code de votre école, votre nom et le numéro ou l'adresse e-mail associé au compte. Ne transmettez jamais de mot de passe ni de code OTP. Nous vérifierons votre identité et coordonnerons la demande avec l'établissement responsable des dossiers scolaires.</p>
          <p>La demande porte sur votre accès, vos coordonnées et les données personnelles associées pouvant être supprimées. Les pièces comptables, dossiers scolaires et journaux indispensables à une obligation légale, à la sécurité ou au règlement d'un litige peuvent être conservés pour la durée nécessaire à cette obligation, avec un accès restreint. Les données des autres personnes ne sont pas supprimées par votre demande. Les éventuelles données conservées et les motifs applicables vous seront précisés lors du traitement.</p>
        </article>

        <article>
          <h2>9. Responsabilité des établissements</h2>
          <p>
            Les établissements utilisant Masomo restent responsables de la
            légitimité des données qu'ils saisissent, des droits qu'ils
            attribuent et des communications qu'ils envoient. Ils doivent
            appliquer les règles de protection des données qui leur sont
            applicables, en particulier pour les données d'élèves et de
            responsables.
          </p>
        </article>

        <article>
          <h2>10. Modifications</h2>
          <p>
            Cette politique peut être mise à jour lorsque le service ou les
            obligations applicables évoluent. La date affichée en haut de la
            page indique la version en vigueur.
          </p>
        </article>
      </section>
    </>
  );
};

export default MasomoPrivacy;
